import React from 'react'
import CloseIcon from '@mui/icons-material/HighlightOff'
import { Alert, IconButton, Snackbar } from '@mui/material'

interface SuccessSnackbarProps {
  setSuccessSnackbarOpen: (value: boolean) => void
  isSuccessSnackbarOpen: boolean
  message: string
}

export default function SuccessSnackbar({
  setSuccessSnackbarOpen,
  isSuccessSnackbarOpen,
  message
}: SuccessSnackbarProps) {
  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === 'clickaway') {
      return
    }

    setSuccessSnackbarOpen(false)
  }
  const action = (
    <>
      <IconButton
        size='small'
        aria-label='close'
        color='inherit'
        onClick={handleClose}
      >
        <CloseIcon fontSize='small' />
      </IconButton>
    </>
  )

  return (
    <Snackbar
      open={isSuccessSnackbarOpen}
      autoHideDuration={6000}
      onClose={handleClose}
      action={action}
      sx={{ width: '100%', justifyContent: 'center' }}
    >
      <Alert onClose={handleClose} severity='success'>
        {message}
      </Alert>
    </Snackbar>
  )
}
